<div class="simulasyon-banner" *ngIf="gorunur">
  <div class="simulasyon-banner__metin">
    <span class="simulasyon-banner__etiket">SİMÜLASYON</span>
    <span>
      Şu anda <b>{{ aciklama }}</b> olarak geziyorsunuz. Gördüğünüz menüler ve yetkiler bu role aittir.
    </span>
  </div>

  <button type="button"
          class="simulasyon-banner__buton"
          [disabled]="bitiriliyor"
          (click)="simulasyonuBitir()">
    {{ bitiriliyor ? 'Dönülüyor...' : 'Süper Admin\'e Dön' }}
  </button>
</div>
